import logo from './logo.svg';
import './App.css';

import CircleLoader from "react-spinners/CircleLoader";

import LoginPage from './LoginPage'

import React, { useEffect } from 'react';
import { useRef, useState } from 'react';

import FeedsTabs from './FeedsTabs';

// Function to check if a token is expired
const isTokenExpired = (token) => {
  if (!token) return true;

  const piecesOfBase64ToDecode = token.split('.');
  // const decodedPieces = piecesOfBase64ToDecode.map((piece) => atob(piece));
  // console.log(`Decoded pieces (${JSON.stringify(decodedPieces)})`);

  const b64DecodedPiece = atob(piecesOfBase64ToDecode[1]);
  console.log(`Checking token for validity (${b64DecodedPiece})`);

  const payload = JSON.parse(b64DecodedPiece);
  return payload.exp * 1000 < Date.now();
};

function App() {
  const [loading, setLoading] = useState(true);
  const [loggedIn, setIsLoggedIn] = useState(false);
  const [idToken, setIdToken] = useState(sessionStorage.getItem('auth-id-token'));
  const [refreshToken, setRefreshToken] = useState(sessionStorage.getItem('auth-refresh-token'));

  useEffect(() => {
    setLoading(true);

    // Check session data on component mount
    const authIdToken = sessionStorage.getItem('auth-id-token');
    console.log(`authIdToken (${authIdToken})`);
    if (authIdToken) {
      setIdToken(authIdToken);
      setIsLoggedIn(true);
    }

    const authRefreshToken = sessionStorage.getItem('auth-refresh-token');
    if(authRefreshToken) {
      setRefreshToken(authRefreshToken);
    }

    console.log("Checking if auth id token is expired");
    // Check if the idToken is expired
    if (isTokenExpired(authIdToken)) {// || isTokenExpired(authRefreshToken)) {
      setIdToken(null);
      setRefreshToken(null);

      sessionStorage.removeItem('auth-refresh-token');
      sessionStorage.removeItem('auth-id-token');

      setIsLoggedIn(false);
    }

    setLoading(false);
    
  }, []);

  // if (loggedIn && loading) {
  //   return <div>
  //     <CircleLoader loading={loading} />
  //   </div>
  //   ; // Adjust based on your spinner
  // }

  return (
    <div className="App">
      <CircleLoader size="50px" loading={loading} />

      {loggedIn && 
      <FeedsTabs idToken={idToken} setIsLoggedIn={setIsLoggedIn} isLoggedIn={loggedIn} setLoading={setLoading}></FeedsTabs>
      }
      {(!loggedIn) &&
      <LoginPage setIsLoggedIn={setIsLoggedIn} setIdToken={setIdToken} setRefreshToken={setRefreshToken} setLoading={setLoading}></LoginPage>
      }
      
    </div>
  );
}

export default App;
